function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 0.3px;\n      }\n\n      .cls-1 {\n        stroke: #ebe9e8;\n      }\n\n      .cls-2 {\n        stroke: #000;\n      }\n\n      .cls-3 {\n        fill: #ebe9e8;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(-100.991 -105.964)"
}, /*#__PURE__*/React.createElement("text", {
  id: "Warszawa",
  className: "cls-1 text",
  transform: "translate(131.55 644)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Warszawa")), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(53.008 13.687)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  className: "cls-1",
  x2: 362.867,
  y2: 497.418,
  transform: "translate(159.318 116.058)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_26",
  "data-name": "Line 26",
  className: "cls-1",
  x2: 288.166,
  y2: 513.629,
  transform: "translate(203.487 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_27",
  "data-name": "Line 27",
  className: "cls-1",
  x1: 271.291,
  y2: 353.083,
  transform: "translate(86.787 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  className: "cls-1",
  x1: 307.033,
  y2: 361.757,
  transform: "translate(65.769 131.131)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_29",
  "data-name": "Line 29",
  className: "cls-1",
  x2: 333.42,
  y2: 489.88,
  transform: "translate(240.294 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_30",
  "data-name": "Line 30",
  className: "cls-1",
  x2: 13.64,
  y2: 430.726,
  transform: "translate(418.055 235.505)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_31",
  "data-name": "Line 31",
  className: "cls-1",
  x1: 66.235,
  y2: 472.53,
  transform: "translate(381.249 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_32",
  "data-name": "Line 32",
  className: "cls-1",
  x2: 71.464,
  y2: 16.67,
  transform: "translate(249.807 673.768)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_33",
  "data-name": "Line 33",
  className: "cls-1",
  x2: 203.973,
  y2: 105.513,
  transform: "translate(198.276 583.328)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_34",
  "data-name": "Line 34",
  className: "cls-1",
  y1: 15.073,
  x2: 215.637,
  transform: "translate(247.656 628.548)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_35",
  "data-name": "Line 35",
  className: "cls-1",
  x1: 287.101,
  y1: 105.513,
  transform: "translate(159.318 553.182)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_36",
  "data-name": "Line 36",
  className: "cls-1",
  x2: 317.612,
  y2: 385.507,
  transform: "translate(100.425 296.937)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_37",
  "data-name": "Line 37",
  className: "cls-1",
  x2: 206.104,
  y2: 537.379,
  transform: "translate(160.402 160.139)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_38",
  "data-name": "Line 38",
  className: "cls-1",
  x2: 330.185,
  y2: 423.19,
  transform: "translate(146.746 198.961)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_39",
  "data-name": "Line 39",
  className: "cls-1",
  x1: 317.631,
  y2: 347.824,
  transform: "translate(72.046 161.278)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_40",
  "data-name": "Line 40",
  className: "cls-1",
  x1: 140.954,
  y2: 453.336,
  transform: "translate(159.318 99.846)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  className: "cls-1",
  x1: 75.767,
  y2: 491.019,
  transform: "translate(188.763 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_42",
  "data-name": "Line 42",
  className: "cls-1",
  x2: 236.645,
  y2: 457.314,
  transform: "translate(100.425 236.644)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_43",
  "data-name": "Line 43",
  className: "cls-1",
  x2: 219.779,
  y2: 489.843,
  transform: "translate(130.938 207.636)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_44",
  "data-name": "Line 44",
  className: "cls-1",
  x1: 147.231,
  y2: 459.734,
  transform: "translate(256.084 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_45",
  "data-name": "Line 45",
  className: "cls-1",
  x1: 117.783,
  y2: 271.319,
  transform: "translate(505.311 342.157)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_46",
  "data-name": "Line 46",
  className: "cls-1",
  x2: 161.934,
  y2: 303.743,
  transform: "translate(469.587 295.798)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_47",
  "data-name": "Line 47",
  className: "cls-1",
  x1: 22.084,
  y2: 248.709,
  transform: "translate(543.184 350.832)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_48",
  "data-name": "Line 48",
  className: "cls-1",
  x1: 591.976,
  y1: 36.544,
  transform: "translate(47.992 501.565)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_49",
  "data-name": "Line 49",
  className: "cls-1",
  x2: 51.54,
  y2: 226.099,
  transform: "translate(94.13 313.149)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_50",
  "data-name": "Line 50",
  className: "cls-1",
  x1: 111.508,
  y2: 423.19,
  transform: "translate(108.854 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_51",
  "data-name": "Line 51",
  className: "cls-1",
  x2: 124.063,
  y2: 566.386,
  transform: "translate(322.356 92.309)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_52",
  "data-name": "Line 52",
  className: "cls-1",
  x1: 182.953,
  y2: 368.155,
  transform: "translate(220.361 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_53",
  "data-name": "Line 53",
  className: "cls-1",
  x1: 212.419,
  y2: 347.824,
  transform: "translate(168.83 220.432)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_54",
  "data-name": "Line 54",
  className: "cls-1",
  x2: 344.927,
  y2: 443.522,
  transform: "translate(101.492 215.173)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_55",
  "data-name": "Line 55",
  className: "cls-1",
  x1: 59.957,
  y2: 338.01,
  transform: "translate(461.142 320.686)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_56",
  "data-name": "Line 56",
  className: "cls-1",
  x2: 52.597,
  y2: 317.678,
  transform: "translate(469.587 295.798)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_57",
  "data-name": "Line 57",
  className: "cls-1",
  x1: 330.202,
  y2: 347.824,
  transform: "translate(271.891 348.554)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  className: "cls-1",
  x1: 425.884,
  y2: 134.52,
  transform: "translate(198.276 448.808)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_59",
  "data-name": "Line 59",
  className: "cls-1",
  x1: 377.589,
  y2: 109.033,
  transform: "translate(240.294 500.426)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_60",
  "data-name": "Line 60",
  className: "cls-1",
  y1: 1.139,
  x2: 516.391,
  transform: "translate(85.702 416.384)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_61",
  "data-name": "Line 61",
  className: "cls-1",
  x1: 318.698,
  y2: 279.994,
  transform: "translate(188.763 304.474)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62",
  "data-name": "Line 62",
  className: "cls-1",
  x2: 425.884,
  y2: 475.946,
  transform: "translate(176.192 108.522)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63",
  "data-name": "Line 63",
  className: "cls-1",
  x1: 44.186,
  y2: 183.157,
  transform: "translate(557.907 416.384)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64",
  "data-name": "Line 64",
  className: "cls-1",
  x1: 552.096,
  y1: 107.79,
  transform: "translate(86.787 454.068)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_65",
  "data-name": "Line 65",
  className: "cls-1",
  x1: 174.527,
  y2: 429.055,
  transform: "translate(286.614 275.466)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_66",
  "data-name": "Line 66",
  className: "cls-1",
  x1: 118.851,
  y2: 368.155,
  transform: "translate(402.249 320.686)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_67",
  "data-name": "Line 67",
  className: "cls-1",
  x1: 0.018,
  y2: 250.987,
  transform: "translate(543.184 348.554)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_68",
  "data-name": "Line 68",
  className: "cls-1",
  x1: 464.842,
  y1: 272.459,
  transform: "translate(160.402 160.139)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  className: "cls-1",
  x2: 199.828,
  y2: 264.921,
  transform: "translate(418.055 235.505)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_70",
  "data-name": "Line 70",
  className: "cls-1",
  x2: 31.598,
  y2: 105.925,
  transform: "translate(358.078 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_71",
  "data-name": "Line 71",
  className: "cls-1",
  x1: 206.122,
  y2: 474.807,
  transform: "translate(168.83 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_72",
  "data-name": "Line 72",
  className: "cls-1",
  x2: 117.766,
  y2: 567.525,
  transform: "translate(300.272 99.846)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_73",
  "data-name": "Line 73",
  className: "cls-2",
  x2: 332.336,
  y2: 430.726,
  transform: "translate(159.318 183.888)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_74",
  "data-name": "Line 74",
  className: "cls-1",
  x1: 186.19,
  y2: 418.979,
  transform: "translate(321.271 271.459)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_75",
  "data-name": "Line 75",
  className: "cls-1",
  x1: 514.241,
  y1: 54.08,
  transform: "translate(94.13 433.735)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_76",
  "data-name": "Line 76",
  className: "cls-1",
  x1: 554.265,
  y1: 202.35,
  transform: "translate(85.702 335.759)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_77",
  "data-name": "Line 77",
  className: "cls-1",
  x1: 66.253,
  y2: 260.347,
  transform: "translate(109.939 108.522)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_78",
  "data-name": "Line 78",
  className: "cls-1",
  x1: 7.361,
  y2: 150.733,
  transform: "translate(94.13 215.173)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_79",
  "data-name": "Line 79",
  className: "cls-1",
  x2: 28.379,
  y2: 345.546,
  transform: "translate(130.938 207.636)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_80",
  "data-name": "Line 80",
  className: "cls-1",
  x2: 50.446,
  y2: 46.359,
  transform: "translate(58.408 470.279)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_81",
  "data-name": "Line 81",
  className: "cls-1",
  x1: 234.493,
  y2: 300.327,
  transform: "translate(108.863 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_82",
  "data-name": "Line 82",
  className: "cls-1",
  x2: 58.892,
  y2: 113.049,
  transform: "translate(565.268 350.832)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_83",
  "data-name": "Line 83",
  className: "cls-1",
  x2: 229.274,
  y2: 581.459,
  transform: "translate(188.763 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_84",
  "data-name": "Line 84",
  className: "cls-1",
  x1: 258.721,
  y2: 346.685,
  transform: "translate(188.763 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_85",
  "data-name": "Line 85",
  className: "cls-1",
  y1: 195.952,
  x2: 154.592,
  transform: "translate(100.425 100.985)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_86",
  "data-name": "Line 86",
  className: "cls-1",
  x1: 61.044,
  y2: 459.734,
  transform: "translate(159.318 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_87",
  "data-name": "Line 87",
  className: "cls-1",
  x1: 23.168,
  y2: 362.897,
  transform: "translate(446.419 295.798)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_88",
  "data-name": "Line 88",
  className: "cls-1",
  x1: 36.807,
  y2: 67.83,
  transform: "translate(602.075 516.638)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_89",
  "data-name": "Line 89",
  className: "cls-1",
  x1: 332.354,
  y2: 38.822,
  transform: "translate(241.361 590.865)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_90",
  "data-name": "Line 90",
  className: "cls-1",
  x2: 154.593,
  y2: 30.147,
  transform: "translate(247.656 658.695)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_91",
  "data-name": "Line 91",
  className: "cls-1",
  x2: 44.169,
  y2: 420.912,
  transform: "translate(382.315 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_92",
  "data-name": "Line 92",
  className: "cls-1",
  x1: 7.361,
  y2: 113.049,
  transform: "translate(93.064 402.45)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_93",
  "data-name": "Line 93",
  className: "cls-1",
  x1: 14.705,
  y1: 55.034,
  transform: "translate(64.703 461.605)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_94",
  "data-name": "Line 94",
  className: "cls-1",
  x2: 6.277,
  y2: 604.069,
  transform: "translate(279.253 93.448)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_95",
  "data-name": "Line 95",
  className: "cls-1",
  x1: 256.568,
  y2: 344.408,
  transform: "translate(176.192 237.783)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_96",
  "data-name": "Line 96",
  className: "cls-1",
  x2: 1.067,
  y2: 256.246,
  transform: "translate(528.478 348.554)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_97",
  "data-name": "Line 97",
  className: "cls-1",
  x1: 471.137,
  y1: 37.683,
  transform: "translate(154.107 538.109)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_98",
  "data-name": "Line 98",
  className: "cls-1",
  x1: 36.807,
  y2: 75.366,
  transform: "translate(587.352 509.102)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_99",
  "data-name": "Line 99",
  className: "cls-1",
  x1: 24.235,
  y1: 31.565,
  transform: "translate(615.732 559.3)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_100",
  "data-name": "Line 100",
  className: "cls-1",
  x2: 28.361,
  y2: 68.968,
  transform: "translate(588.437 342.157)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_101",
  "data-name": "Line 101",
  className: "cls-1",
  x1: 13.638,
  y1: 38.822,
  transform: "translate(610.522 342.157)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 1",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(307.55 161)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 2",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(175.55 256)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(247.55 296)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 4",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(278.55 449)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 5",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(335.55 430)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 6",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(425.55 627)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_8",
  "data-name": "Ellipse 7",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(384.55 438)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_5",
  "data-name": "Ellipse 8",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(358.55 355)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 9",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(407.55 258)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 10",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(439.55 677)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(385.55 674)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 12",
  className: "cls-3 map__point",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(626.55 469)"
}), /*#__PURE__*/React.createElement("image", {
  className: "map__selected-point",
  x: -24,
  y: -24,
  width: 48,
  height: 48,
  href: "img/selected-point.svg"
}));

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 592.104,
    height: 618.057,
    viewBox: "0 0 592.104 618.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.1c3b77cd.svg";
export { ForwardRef as ReactComponent };